<template>
  <div class="container">
    <div class="box">
      <div class="notification is-danger" v-if="flash">{{flash}}</div>
      <div class="field">
        <label class="label">Type</label>
        <div class="control">
          <b-dropdown v-model="typeSelected">
              <button class="button" slot="trigger" ref="new">
                <template v-if="typeSelected">
                  <b-icon :icon="typeSelected.icon"></b-icon>
                  <span>{{$t(typeSelected.id)}}</span>
                </template>
                <template v-else>
                    <span>{{$t('chooseType')}}</span>
                </template>
                <b-icon icon="caret-down"></b-icon>
              </button>

            <b-dropdown-item v-for="type in types" :key="type.id" :value="type.name" has-link>
              <router-link :to="{ name: type.newRoute }" replace>
                <b-icon :icon="type.icon"></b-icon>
                {{$t(type.id)}}
              </router-link>
            </b-dropdown-item>
          </b-dropdown>
        </div>
      </div>
      <router-view @flash="onFlash"></router-view>
    </div>
  </div>
</template>

<i18n src="../i18n/foodItem-types.i18n.json"></i18n>
<i18n src="../i18n/New.i18n.json"></i18n>

<script>
import _ from 'lodash';
import i18nMixin from '@/mixins/i18n';
import Types from '../foodItem-types';

export default {
  name: 'new',
  mixins: [i18nMixin],
  data() {
    return {
      flash: '',
      typeSelected: this.initTypeSelected(),
    };
  },
  mounted() {
    this.$nextTick(() => this.$refs.new.focus());
  },
  watch: {
    $route() {
      this.typeSelected = this.initTypeSelected();
    },
  },
  methods: {
    initTypeSelected() {
      return _.find(Types.types, t => t.newRoute === this.$router.currentRoute.name);
    },
    onFlash(f) {
      this.flash = f;
      window.scrollTo(0, 0);
    },
  },
  computed: {
    types() {
      return Types.types;
    },
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/New.vue